import { API } from "aws-amplify";
import { useQuery } from "react-query";
import { IOrganization } from "../../../../models/Organization";
import { APIEndpoints, QueryKeys } from "../../config";

const makeApiRequest = (organizationId): Promise<IOrganization> => {
  const qParams = {};

  return API.get(
    APIEndpoints.private,
    `/api/v1/organizations/${organizationId}`,
    qParams
  );
};

export const useReadOrganization = (organizationId?: string) => {
  return useQuery<IOrganization>(
    QueryKeys.organizationDetail(organizationId),
    () => makeApiRequest(organizationId),
    {
      retry: 2,
      enabled: !!organizationId,
    }
  );
};
